// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsLetterBox_container__20s0M","title":"NewsLetterBox_title__3HuwW","content":"NewsLetterBox_content__3eklA"};